export default "__VITE_ASSET__zGAxEHgl__"